import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useImperativeHandle } from "react";
import { GlobalStyles, Box, Stack, Typography } from "@mui/material";
import { spreadSx } from "../../../utils/spreadSx.js";
import { useGoogleMap } from "./useGoogleMap.js";
import { grayMarker } from "./b64Images.js";
import { useGeocoder } from "../../hooks/useGeocoder.js";
import { useInitialization } from "../Autocomplete/useInitialization.js";
import { inheritDataTestId } from "../../../utils/dataTestId.js";
const GoogleMap = ({
  innerRef,
  hideTooltip,
  onChange,
  sx,
  place,
  children,
  searchBy,
  ...props
}) => {
  const [placeFromId, setMapPlaceFromId] = useState(), { mapRef, tooltip, tooltipRef, reset } = useGoogleMap({
    googlePlace: place || placeFromId,
    onChange,
    hideTooltip,
    marker: grayMarker
  });
  useImperativeHandle(innerRef, () => ({ reset }), [reset]);
  const getAddress = useGeocoder();
  return useInitialization({
    getAddress,
    onChange: (address) => {
      setMapPlaceFromId(address);
    },
    searchBy
  }), /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(GlobalStyles, { styles: styles.global }),
    children ? children(mapRef) : /* @__PURE__ */ jsx(Box, { ref: mapRef, sx: [styles.mapBox, ...spreadSx(sx)], ...props }),
    /* @__PURE__ */ jsxs(
      Stack,
      {
        className: "tt-body",
        ref: tooltipRef,
        sx: styles.tooltip,
        "data-test-id": inheritDataTestId(props, "tooltip-contents"),
        children: [
          /* @__PURE__ */ jsx(Typography, { variant: "16_24_500", sx: { pr: 32 }, children: tooltip.header }),
          /* @__PURE__ */ jsx(Box, { children: tooltip.info })
        ]
      }
    )
  ] });
}, styles = {
  mapBox: {
    width: "100%",
    height: { xs: 200, md: 200 },
    boxSizing: "border-box",
    border: (t) => `1px solid ${t.palette.field.border.default}`
  },
  tooltip: { maxWidth: 200, display: "none" },
  global: {
    ".gm-style-iw-ch": { pt: 20 },
    ".gm-style-iw-chr button": {
      position: "absolute!important",
      right: 0
    },
    "button.gm-ui-hover-effect": {
      outline: "none"
    }
  }
};
export {
  GoogleMap
};
//# sourceMappingURL=GoogleMap.js.map
